const routes = {
    'about': '/ABOUT.md',
    'portfolio': '/api/v1/portfolio',
    'contacts': '/api/v1/contacts',
}

export default routes;